<template>
  <b-modal
    :visible="true"
    title="Crop Image"
    hide-footer
    centered
    no-close-on-esc
    no-close-on-backdrop
    @shown="initCropper"
    @hidden="$emit('close')"
  >
    <div>
      <img ref="image" :src="imageUrl" alt="To Crop" class="img-fluid mb-3" />
      <p></p>
      <b-button class="mt-3" variant="primary" @click="crop">Crop & Upload</b-button>
    </div>
  </b-modal>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'CropperModal',
  props: ['imageUrl', 'isFavIcon'],
  data() {
    return {
      cropper: null
    }
  },
  methods: {
    initCropper() {
      if (this.$refs.image) {
        this.cropper = new Cropper(this.$refs.image, {
          aspectRatio: this.isFavIcon ? 1 : 16 / 9,
          viewMode: 1,
          autoCropArea: 1
        })
      } else {
        console.error('Image ref not available yet.')
      }
    },
    crop() {
      const canvas = this.cropper?.getCroppedCanvas({
        width: this.isFavIcon ? 256 : 1200,
        height: this.isFavIcon ? 256 : 1800
      })
      if (canvas) {
        canvas.toBlob(blob => {
          this.$emit('cropped', blob)
          // Only close after cropping
          this.$emit('close')
        }, 'image/webp')
      }
    }
  }
}
</script>